<template>
  <footer>
    <div class="top">
      <ul class="code-ul clearfix">
        <li>
          <img src="@/assets/imgs/service.png" alt />
          <p>服务号</p>
        </li>
        <li>
          <img src="@/assets/imgs/subscribe.png" alt />
          <p>订阅号</p>
        </li>
        <li>
          <img src="@/assets/imgs/android.png" />
          <p>安卓版</p>
        </li>
      </ul>
      <img class="line" src="@/assets/imgs/footer_icon.png" alt />
      <p class="licence">增值电信业务经营许可证 京ICP证030059号</p>
      <p class="licence">增值电信业务经营许可证 京B2-20070136</p>
      <p class="licence">出版物经营许可证 新出发京批字第直210398号</p>
    </div>
    <div class="bottom">
      <p>
        <span>Copyright ©1998-{{currentYear}} DRCNet. All Rights Reserved</span>
        <span>版权所有 国研网</span>
      </p>
    </div>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      currentYear: new Date().getFullYear()
    };
  }
};
</script>

<style lang='scss' scoped>
footer {
  .top {
    background: url(../assets/imgs/footer_bg.png);
    padding-bottom: 33px;
    .code-ul {
      li {
        float: left;
        margin-top: 50px;
        margin-left: 60px;
        p {
          font-size: 22px;
          color: #ffffff;
          line-height: 50px;
          text-align: center;
        }
        img{
          width: 169px;
          height: 169px;
        }
      }
    }
    .line {
      width: 725px;
      height: 2px;
      overflow: hidden;
      margin: 10px auto;

    }
    .licence {
      font-size: 19px;
      color: #ffffff;
      text-align: center;
      margin-top: 16px;
    }
  }
  .bottom {
    background: #750100;
    width: 750px;
    height: 59px;
    font-size: 19px;
    color: #ba7574;
    line-height: 59px;
    p {
      text-align: center;
      span:last-child {
        margin-left: 20px;
      }
    }
  }
}
</style>